import { GREY3 } from '@swegon-core/uic/dist/src/theme';
import { styled } from 'styled-components';

export const UnitSelectorContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    column-gap: 8px;
    select {
        width: 80px;
    }
`;

export const UnitSelectorLabel = styled.span`
    font: 400 0.875rem/1.25rem 'SwegonBrown';
    color: ${GREY3};
    white-space: nowrap;
`;
